import { formatKarachiDateTime } from '@/lib/dates'
import { formatPKR } from '@/lib/money'

export interface ReceiptInfo {
  shopName?: string
  model: string
  imeis: string[]
  saleAmount: number
  received: number
  balance: number
  soldAt: string
  customer?: string | null
}

/** WhatsApp-friendly sale receipt (bold via *asterisks*, line breaks preserved). */
export function buildReceiptText(r: ReceiptInfo): string {
  const lines = [
    `*${r.shopName?.trim() ? r.shopName.trim() : 'Mobile Trading Pro'}*`,
    '— RECEIPT —',
    `Item: ${r.model}`,
    ...(r.imeis.length > 0 ? [`IMEI: ${r.imeis.join(' / ')}`] : []),
    `Customer: ${r.customer?.trim() ? r.customer : 'Walk-in'}`,
    `Date: ${formatKarachiDateTime(r.soldAt)}`,
    `Amount: ${formatPKR(r.saleAmount)}`,
    `Received: ${formatPKR(r.received)}`,
    r.balance > 0 ? `Balance (udhaar): ${formatPKR(r.balance)}` : 'Balance: Paid in full ✔',
    'Shukriya!',
  ]
  return lines.join('\n')
}

export interface ReminderInfo {
  customer: string | null
  model: string
  balance: number
  soldAt: string
}

/** Roman-Urdu payment reminder for outstanding udhaar. */
export function buildReminderText(r: ReminderInfo): string {
  const who = r.customer?.trim() && r.customer !== 'Walk-in' ? ` (${r.customer})` : ''
  return [
    'Assalam-o-Alaikum,',
    `Yad-dehani: ${r.model}${who} ke babad ${formatPKR(r.balance)} baqi hai.`,
    `Sale date: ${formatKarachiDateTime(r.soldAt)}`,
    'Barae-meherbani adai gi farma dein. Shukriya!',
  ].join('\n')
}
